import React from 'react';
import Icon from '../../../components/AppIcon';
import { getTranslation } from '../../../utils/translations';

const ComplianceTrackingSection = ({ countries, language }) => {
  const t = getTranslation(language);

  const getComplianceStatus = (requirements) => {
    if (!requirements || Object.keys(requirements)?.length === 0) {
      return { status: 'unknown', label: language === 'FR' ? 'Non défini' : language === 'PL' ? 'Nieokreślony' : 'Unknown', color: 'bg-gray-100 text-gray-700' };
    }
    const hasAllRequired = Object.values(requirements)?.every(val => val === true);
    if (hasAllRequired) {
      return { status: 'compliant', label: language === 'FR' ? 'Conforme' : language === 'PL' ? 'Zgodny' : 'Compliant', color: 'bg-green-100 text-green-700' };
    }
    return { status: 'pending', label: language === 'FR' ? 'En cours' : language === 'PL' ? 'W toku' : 'Pending', color: 'bg-yellow-100 text-yellow-700' };
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4">
        {countries?.map((country) => {
          const compliance = getComplianceStatus(country?.regulatoryRequirements);
          
          return (
            <div
              key={country?.id}
              className="bg-background border border-border rounded-lg p-6 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-semibold text-foreground text-lg">{country?.countryName}</h3>
                  <p className="text-sm text-muted-foreground">{country?.region?.region_name}</p>
                </div>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${compliance?.color}`}>
                  {compliance?.label}
                </span>
              </div>

              <div className="space-y-3">
                <div>
                  <p className="text-sm font-medium text-foreground mb-2">
                    {t?.international?.regulatoryRequirements || 'Regulatory Requirements'}:
                  </p>
                  {country?.regulatoryRequirements && Object.keys(country?.regulatoryRequirements)?.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      {Object.entries(country?.regulatoryRequirements)?.map(([key, value]) => (
                        <div key={key} className="flex items-center gap-2 text-sm">
                          <Icon 
                            name={value ? 'CheckCircle' : 'XCircle'} 
                            size={16} 
                            className={value ? 'text-green-600' : 'text-red-600'} 
                          />
                          <span className="text-muted-foreground capitalize">
                            {key?.replace(/_/g, ' ')}
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-sm text-muted-foreground">
                      {language === 'FR' && 'Aucune exigence définie'}
                      {language === 'EN' && 'No requirements defined'}
                      {language === 'PL' && 'Brak zdefiniowanych wymagań'}
                    </p>
                  )}
                </div>

                <div className="pt-3 border-t border-border">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-muted-foreground">
                      {language === 'FR' && 'Dernière vérification:'}
                      {language === 'EN' && 'Last checked:'}
                      {language === 'PL' && 'Ostatnio sprawdzono:'}
                    </span>
                    <span className="text-foreground font-medium">
                      {new Date(country?.updatedAt || country?.createdAt)?.toLocaleDateString(language === 'FR' ? 'fr-FR' : language === 'PL' ? 'pl-PL' : 'en-GB')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {countries?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="Shield" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">{t?.common?.noData || 'No data available'}</p>
        </div>
      )}
    </div>
  );
};

export default ComplianceTrackingSection;